import type { DeviceModel } from '../../types/deviceModel';
import { portRow, powerPort, simpleLayout } from './layoutHelpers';
import type { MultiFaceLayout } from '../../types';

const atOut = {
  standards: ['802.3af', '802.3at'] as const,
  perPortMaxWatts: 15.4,
  modeDefault: 'auto' as const,
};

/** UniFi Switch 24 PoE — ports 1–16 AF/AT, 17–24 data, 2× SFP. */
export const us24PoeModel: DeviceModel = {
  equipmentId: 'ubnt-us-24-poe',
  selfDrawWatts: 25,
  powerInputs: [{ id: 'ac', kind: 'ac', portNumber: 1, face: 'back', maxWatts: 250 }],
  layout: {
    multiFace: {
      defaultFace: 'front',
      faces: {
        front: simpleLayout(
          [
            ...portRow({
              count: 16,
              startNumber: 1,
              kind: 'rj45',
              speedsMbps: [10, 100, 1000],
              poeOut: { ...atOut, standards: [...atOut.standards] },
              y: 12,
            }),
            ...portRow({
              count: 8,
              startNumber: 17,
              kind: 'rj45',
              speedsMbps: [10, 100, 1000],
              y: 40,
              flipped: true,
            }),
            ...portRow({
              count: 2,
              startNumber: 1,
              kind: 'sfp',
              speedsMbps: [1000],
              startX: 12 + 24 * 8,
              y: 40,
              flipped: true,
              idPrefix: 'sfp',
            }),
          ],
          420,
          80
        ),
        back: simpleLayout(
          [powerPort({ number: 1, kind: 'ac', label: 'AC in', x: 12, y: 20 })],
          140,
          70
        ),
      },
    } as MultiFaceLayout,
  },
};
